import ApiClient from "@/domain/core/utils/apiClient";
import client_core from "@/services/clients/client_core";
import MD5 from "crypto-js/md5";
import {ValidationError} from "@/domain/core/exception/exceptions";
import {chunk} from "lodash";

const client = new ApiClient(client_core)

const endpoints = {
    config: '/dashboard/v2/uploader/{id}/uploader/configuration/', // GET
    upload_intent: '/uploads/pica-services/{id}/hd-upload-intents/', // POST
    available_tags: `/dashboard/v2/uploader/{id}/uploader/available_tags/`, // GET
    available_galleries: '/dashboard/v2/photo-search/{id}/galleries/', // GET
    validate_pica_code: '/dashboard/v2/uploader/{id}/uploader/pica_code_validation/{pica_code}/', // GET
    stats: '/dashboard/v2/uploader/{id}/uploader/stats/', // GET
}

export default {
    async fetchConfig(pica_service_id) {
        return await client.get(endpoints.config.replace('{id}', pica_service_id))
    },
    generateMd5(file) {
        return MD5(`${file.size}_${file.name.replace(' ', '')}`).toString()
    },
    async fetchUploadIntent(pica_service_id, photographer_id,gallery_id, files) {
        const promises = chunk(files, 50).map(files => client.post(endpoints.upload_intent.replace('{id}', pica_service_id), {
            'medias': files.map(file => {
                let options = {
                    md5: file.md5,
                    src: file.name,
                    author: photographer_id,
                }
                if (file.free) options.free = true
                if (file.public) options.public = true
                if (file.disableAutotag) options.autotag = false
                if (file.tags && file.tags.length) options.tags = file.tags
                if (file.picaCode && file.picaCode.length) options.picacodes = [file.picaCode.toUpperCase()]
                if (gallery_id) options.gallery = gallery_id
                else if (file.gallery) options.gallery = file.gallery.id
                return options
            })
        }))
        const data = {
            payloads: [],
            existing: [],
            url: null,
        }
        const results = await Promise.all(promises)
        for (let i = 0; i < results.length; i++) {
            const result = results[i]
            data.existing.push(...result.existing)
            data.payloads.push(...result.payloads)
            data.url = result.url
        }
        return data
    },
    async fetchAvailableTags(pica_service_id) {
        return await client.get(endpoints.available_tags.replace('{id}', pica_service_id))
    },
    async fetchAvailableGalleries(pica_service_id) {
        return await client.get(endpoints.available_galleries.replace('{id}', pica_service_id))
    },
    async validatePicaCode(pica_service_id, pica_code) {
        try {
            await client.get(endpoints.validate_pica_code
                .replace('{id}', pica_service_id)
                .replace('{pica_code}', pica_code))
            return true
        } catch (e) {
            if (e instanceof ValidationError) return false
            throw e
        }
    },
    async fetchStats(pica_service_id) {
        return await client.get(endpoints.stats.replace('{id}', pica_service_id))
    }
}
